export function Logo({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" className={className}>
      <defs>
        <style>
          {`@import url('https://fonts.googleapis.com/css2?family=La+Belle+Aurore&family=Silkscreen:wght@400;700&display=swap');`}
        </style>
      </defs>
      {/* Plate circle */}
      <circle cx="150" cy="150" r="140" fill="#1A1A1A" />
      <circle cx="150" cy="150" r="130" fill="none" stroke="#FFBF05" strokeWidth="4" />
      <circle
        cx="150"
        cy="150"
        r="100"
        fill="none"
        stroke="#FFBF05"
        strokeWidth="2"
        opacity="0.4"
      />
      {/* Pixel/Digital Effect - Small squares scattered on plate */}
      <g fill="#FFBF05">
        {/* Top area pixels */}
        <rect x="45" y="95" width="4" height="4" opacity="0.3" />
        <rect x="55" y="88" width="3" height="3" opacity="0.2" />
        <rect x="68" y="78" width="5" height="5" opacity="0.4" />
        <rect x="82" y="85" width="3" height="3" opacity="0.25" />

        {/* Left side pixels */}
        <rect x="35" y="120" width="4" height="4" opacity="0.35" />
        <rect x="28" y="140" width="5" height="5" opacity="0.3" />
        <rect x="32" y="160" width="3" height="3" opacity="0.2" />
        <rect x="38" y="180" width="4" height="4" opacity="0.4" />
        <rect x="45" y="200" width="3" height="3" opacity="0.25" />
        <rect x="55" y="215" width="4" height="4" opacity="0.3" />

        {/* Right side pixels */}
        <rect x="255" y="110" width="4" height="4" opacity="0.3" />
        <rect x="262" y="130" width="3" height="3" opacity="0.25" />
        <rect x="265" y="150" width="5" height="5" opacity="0.4" />
        <rect x="260" y="175" width="4" height="4" opacity="0.2" />
        <rect x="252" y="195" width="3" height="3" opacity="0.35" />
        <rect x="240" y="210" width="4" height="4" opacity="0.3" />

        {/* Bottom area pixels */}
        <rect x="70" y="230" width="4" height="4" opacity="0.25" />
        <rect x="90" y="242" width="3" height="3" opacity="0.3" />
        <rect x="200" y="238" width="4" height="4" opacity="0.35" />
        <rect x="220" y="228" width="3" height="3" opacity="0.2" />

        {/* Inner scattered pixels */}
        <rect x="60" y="130" width="3" height="3" opacity="0.15" />
        <rect x="75" y="170" width="4" height="4" opacity="0.2" />
        <rect x="55" y="155" width="3" height="3" opacity="0.18" />
        <rect x="230" y="125" width="3" height="3" opacity="0.15" />
        <rect x="220" y="165" width="4" height="4" opacity="0.2" />
        <rect x="235" y="145" width="3" height="3" opacity="0.18" />

        {/* Extra small accent pixels */}
        <rect x="48" y="108" width="2" height="2" opacity="0.5" />
        <rect x="250" y="118" width="2" height="2" opacity="0.5" />
        <rect x="42" y="190" width="2" height="2" opacity="0.45" />
        <rect x="255" y="185" width="2" height="2" opacity="0.45" />
        <rect x="80" y="235" width="2" height="2" opacity="0.4" />
        <rect x="210" y="232" width="2" height="2" opacity="0.4" />
      </g>
      {/* Chef Hat */}
      <circle cx="130" cy="52" r="16" fill="#FFF" />
      <circle cx="150" cy="45" r="18" fill="#FFF" />
      <circle cx="170" cy="52" r="16" fill="#FFF" />
      <rect x="125" y="55" width="50" height="20" rx="3" fill="#FFF" />
      <rect x="125" y="70" width="50" height="5" rx="2" fill="#FFBF05" />
      {/* Fork and Spoon */}
      <g transform="translate(100, 85) scale(0.9)" fill="#FFBF05">
        <path d="m69.2146606 43.5078506c6.382164.5501328 13.9190445-2.3648872 19.8843765-8.3301582 9.1497116-9.1497707 11.1325455-22.0014629 4.4286423-28.7054424-6.7038345-6.7037158-19.5557404-4.721066-28.7054596 4.4286461-5.9652596 5.965332-8.8802185 13.5022736-8.3300819 19.8843689.3034134 3.4708462-.7038765 6.9294949-2.8234596 9.6946697-1.0274658 1.3369026-2.2089844 2.7323074-3.6311874 4.2648048-1.0190201-1.2429733-1.8894424-2.4180374-2.6765709-3.5869789-.9474716-1.4584885-1.2028503-3.2608185-.6978722-4.9251175 1.3890915-4.8732815.0282288-10.1166306-3.5555267-13.699255-6.4365426-6.4366016-17.0654602-16.1316776-20.8164273-19.5337534-.764183-.6921556-1.9374352-.6614783-2.6644001.0696666l-.0667438.0667427c-.7558517.755909-.7558517 1.98142 0 2.737329l18.7350483 18.7350502c.7562218.7566853.7558441 1.9831371-.0008392 2.739357-.0765419.0764961-.1593628.1464405-.2475853.2091045-.8101387.5384274-1.8897171.4186287-2.5620995-.2843132l-18.6618538-18.661827c-.7566071-.756166-1.9829502-.7558084-2.7391167.0007992-.0765676.0766115-.1465731.1595116-.209281.2478266-.5383291.8100786-.4185619 1.8895264.2842512 2.5618963l18.6618881 18.66189c.7562141.7566967.755825 1.9831543-.0008698 2.7393684-.0765343.0764847-.1593437.1464233-.2475586.2090836-.8101559.5383835-1.889719.41856-2.5620956-.2843781l-18.6618861-18.6617536c-.7565308-.7561846-1.9828291-.7559042-2.7390127.0006275-.0766048.0766373-.1466417.1595716-.2093744.2479239-.5383716.8100948-.4186015 1.8895893.2842503 2.5619698l18.6618576 18.6618137c.7561951.756649.7558289 1.9830551-.0008221 2.7392502-.0765839.076538-.1594506.1465224-.2477303.2092132-.8100872.5384178-1.8896275.4186172-2.5619583-.2843132l-18.6618686-18.6618271c-.7558751-.7558918-1.9814048-.7559052-2.7372971-.0000324-.0000107.0000095-.0000217.0000229-.0000322.0000324l-.0667429.0667439c-.7310543.7269115-.7616398 1.9000664-.0694559 2.6640835 3.401823 3.7512016 13.0968552 14.3800697 19.5335655 20.8166161 3.5826244 3.5837669 8.825985 4.9446411 13.6992779 3.5555458 1.6642876-.5050087 3.4666176-.2496529 4.9251175.6977959 1.1674423.7861862 2.3408546 1.6552277 3.582016 2.6725845-7.1398811 6.717556-18.5161247 16.2183189-38.2694168 32.128582-5.4488276 4.3885726-4.6761612 9.4076766-1.3581604 12.7256774 3.3181272 3.3181915 8.3370399 4.0905914 12.7257748-1.3581009 25.1020622-31.1653633 34.2595749-41.493618 41.6821136-47.1983452 2.7651715-2.1195488 6.2237897-3.1268387 9.6946072-2.8234673z" />
        <path d="m93.7423325 82.9835815c-18.1214753-14.5958175-28.790535-23.4899253-35.5830994-29.8124771-1.4924927 1.3860588-3.1290474 3.0209351-4.9853859 4.9909515 6.322258 6.7926865 15.2158241 17.4613113 29.8097725 35.5802155 4.1535492 5.1569748 8.903801 4.4258041 12.0440521 1.2854996 3.1402512-3.1403122 3.871582-7.8906403-1.2853393-12.0441895z" />
      </g>
      <text
        x="150"
        y="205"
        textAnchor="middle"
        fontFamily="'Silkscreen', sans-serif"
        fontSize="35"
        fontWeight="500"
        fill="#FFF"
        letterSpacing="2"
      >
        Digi
      </text>
      <text
        x="150"
        y="245"
        textAnchor="middle"
        fontFamily="'La Belle Aurore', sans-serif"
        fontSize="44"
        fontWeight="800"
        fill="#FFBF05"
        letterSpacing="1"
      >
        Mat3am
      </text>{' '}
    </svg>
  );
}
